import { render } from "./ApplicantLayout.vue?vue&type=template&id=1233aefc&scoped=true"
import script from "./ApplicantLayout.vue?vue&type=script&lang=ts"
export * from "./ApplicantLayout.vue?vue&type=script&lang=ts"

import "./ApplicantLayout.vue?vue&type=style&index=0&id=1233aefc&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1233aefc"
/* custom blocks */
import block0 from "./ApplicantLayout.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script